import React, { Fragment, useEffect, useState } from 'react'
import axios from 'axios'

import { institucionPorId, obtenerInstituciones } from '../../Services/Rest'
import { MDBCollapse, MDBBtn } from 'mdb-react-ui-kit';
import Cookies from 'universal-cookie';
import EditarInstitucion from './EditarInstitucion';
import PerfilAutoevaluacio from './PerfilAutoevaluacion';
import InfoPerfil from './InfoPerfil';
import InfoPerfilAdmin from './InfoPerfilAdmin';

const cookie = new Cookies();

if (cookie.get('tipo_Usuario') == 1) {
  var urlendpoint = obtenerInstituciones;
} if (cookie.get('tipo_Usuario') == 2) {
  var urlendpoint = institucionPorId + cookie.get("institucionid");
} if (cookie.get('tipo_Usuario') == 3) {
  var urlendpoint = obtenerInstituciones;
} if (cookie.get('tipo_Usuario') == 4)
  var urlendpoint = obtenerInstituciones;

function InstitucionPerfilAdmin() {
  const [showShow, setShowShow] = useState(false);
  const toggleShow = () => setShowShow(!showShow);

  const cookies = new Cookies();
  const [list, setList] = useState([]);

  const [search, setSearch] = useState("")
  const searcher = (e) => {
    setSearch(e.target.value)
  }
  const results = !search ? list : list.filter((dato) => dato.razon_Social.toLowerCase().includes(search.toLocaleLowerCase(),))
  useEffect(() => {
    showData()
  }, [])


  const URL = urlendpoint
  const showData = async () => {
    const response = await fetch(URL)
    const data = await response.json()
    //console.log(data)
    setList(data)
  }

  const stringCapitulo = list.map((item) => {
    return (
      (item.id)
    )
  })
  const Id = stringCapitulo.join(list.map((item) => {
    return (
      (item.id)
    )
  }))

  return (
    <Fragment>

      <div className="container">
        <div className="text-center">
          <div class="container-fluid">
            <div class="card shadow mb-4">
              <div class="card-header py-3">

                {cookies.get('tipo_Usuario') == 1
                  ? <h6 class="m-0 font-weight-bold text-primary">Instituciones</h6>
                  : <h6 class="m-0 font-weight-bold text-primary">Institución</h6>
                }
              </div>

              <div class="card-body">
                <input value={search} onChange={searcher} type="text" placeholder='Buscar por razon social' className='form-control' />

                <hr />
                <div class="table-responsive">
                  <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0">
                    <thead>
                      <tr>

                        <th>Razon Social</th>
                        <th>Nit</th>

                        <th>Codigo Prestador</th>

                        <th>Editar</th>
                      </tr>
                    </thead>
                    <tbody>
                      {results.map((item) => {
                        return (
                          <tr>

                            <td>{item.razon_Social}</td>
                            <td>{item.nit}</td>
                            <td>{item.codigo_prestador}</td>
                            {cookie.get("institucionid") == 1
                              ? <td><InfoPerfilAdmin idInstitucion={item.id} /></td>
                              : <td><EditarInstitucion idIntitucion={item.id} /></td>
                            }
                          </tr>
                        )
                      })
                      }
                    </tbody>
                  </table>
                  {cookie.get("institucionid") != 1
                    ? <PerfilAutoevaluacio InstitucionId={Id} />
                    : <h1></h1>
                  }

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

    </Fragment>
  )
}
export default InstitucionPerfilAdmin;